import {
  FilterMode,
  AiSearchToolCall_OrderBy,
  AiSearchToolCall,
  SortOrder,
  AiSearchToolCall_Filter,
} from "../../../api/graphql";
import { getApiInstance } from "../../../api";
import { nullToUndefinedRecursive } from "../../../common/utils";

export const aiSearchToolCallService = {
  createOne: () => (): Promise<string> => new Promise(() => ""),
  getOne: async (id: string, accessToken: string, activityStore: any) => {
    const api = getApiInstance(accessToken, activityStore);
    const result = await api.aiSearchToolCallOne({ id });
    return result.aiSearchToolCallOne as AiSearchToolCall;
  },
  getFilteredList: async (
    accessToken: string,
    offset: number,
    take: number,
    searchValue: string,
    _language: string = "es",
    orderBy: AiSearchToolCall_OrderBy[] | null = null,
    filter: AiSearchToolCall_Filter | null = null,
    activityStore: any
  ) => {
    const api = getApiInstance(accessToken, activityStore);

    let where: AiSearchToolCall_Filter | undefined;
    if (searchValue !== "") {
      where = {
        toolName: { contains: searchValue, mode: FilterMode.Insensitive },
      };
    }

    if (filter) {
      if (where) {
        where = { AND: [filter, where] };
      } else {
        where = filter;
      }
    }

    const result = await api.aiSearchToolCallListWithOffset({
      offset,
      take,
      orderBy: orderBy ? orderBy : [{ toolName: SortOrder.Asc }],
      where,
    });
    const list = nullToUndefinedRecursive(
      result.aiSearchToolCallListWithOffset
    ) as AiSearchToolCall[];
    return { list, orderBy };
  },
};
